import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchClient } from "@babackapp/private-api-client/generated/client";
import { SESSION_TOKEN_KEY } from "@babackapp/private-api-client/client/use-session-token";
import { buildReturnRequestPayload } from "../lib/return-request.lib";
import type { ReturnDraft } from "../types";

export function useCreateReturnRequest(orderId: string, shopSlug: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (draft: ReturnDraft) => {
      const payload = buildReturnRequestPayload(draft);
      const { data, response } = await fetchClient.POST(
        "/public/return-request",
        {
          body: payload as any,
          params: {
            header: {
              authorization: `Bearer ${localStorage.getItem(SESSION_TOKEN_KEY) ?? ""}`,
            },
          },
        },
      );

      if (!response.ok) throw new Error("Failed to create return request");
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          "get",
          "/public/return-request/search",
          { params: { query: { orderId, shopSlug } } },
        ],
      });
    },
  });
}
